import { render } from "./ConsumoTrimestral.vue?vue&type=template&id=28752090"
import script from "./ConsumoTrimestral.vue?vue&type=script&lang=js"
export * from "./ConsumoTrimestral.vue?vue&type=script&lang=js"

import "./ConsumoTrimestral.vue?vue&type=style&index=0&id=28752090&lang=css"

import exportComponent from "/home/nodejs/front/oxyplus-acuicultura-monitorweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__